import {
  Cell as TCell,
  Column as TColumn,
  Row as TRow,
  Table as TTable,
} from '@tanstack/react-table';

export type CellFnProps = {
  table: TTable<object>;
  row: TRow<object>;
  column: TColumn<object>;
  cell: TCell<object, any>;
  getValue: () => any;
  renderValue: () => any;
};

export function makeDatetimeCellFunction(format: Intl.DateTimeFormatOptions) {
  return function DatetimeFunction(props: CellFnProps) {
    const value = props.getValue();
    if (!value) {
      return null;
    }
    return new Date(value).toLocaleString('en-US', format);
  };
}

export function Rounded(props: CellFnProps) {
  const value = props.getValue();
  if (value === undefined || value === null) {
    return null;
  }
  return Math.round(value);
}
